var _path, _circle, _rect, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _path4, _path5, _path6, _path7, _polygon, _polygon2, _rect2, _rect3, _rect4, _polygon3, _polygon4, _rect5, _rect6, _polygon5, _polygon6, _rect7, _rect8, _polygon7, _polygon8, _rect9, _rect10, _rect11, _polygon9, _polygon10, _rect12, _rect13, _polygon11, _polygon12, _rect14, _rect15, _polygon13, _polygon14, _rect16, _rect17, _polygon15, _polygon16, _rect18, _rect19, _polygon17, _polygon18, _rect20, _rect21, _polygon19, _polygon20, _rect22, _rect23, _polygon21, _polygon22, _rect24, _rect25, _polygon23, _polygon24, _rect26, _rect27, _polygon25, _polygon26, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _polygon27, _polygon28, _rect34, _rect35, _polygon29, _polygon30, _rect36, _rect37, _polygon31, _polygon32, _rect38, _rect39, _polygon33, _polygon34, _rect40, _rect41, _polygon35, _polygon36, _rect42, _rect43, _polygon37, _polygon38, _rect44, _rect45, _polygon39, _polygon40, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _polygon41, _polygon42, _rect52, _rect53, _polygon43, _polygon44, _rect54, _rect55, _polygon45, _polygon46, _rect56, _rect57, _polygon47, _polygon48, _rect58, _rect59, _polygon49, _polygon50, _rect60, _rect61, _polygon51, _polygon52, _rect62, _rect63, _polygon53, _polygon54, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path8, _rect72, _path9, _rect73, _path10, _ellipse, _path11, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCityLocationsRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1137,
    height: 518.05664,
    viewBox: "0 0 1137 518.05664",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "best place") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.76416,701.583l-1.95117-.43946c21.75586-96.751,76.43017-184.60937,153.95117-247.3916A444.114,444.114,0,0,1,1039.919,699.96289l-1.94922.44336C991.916,498.19727,814.69531,356.97168,607,356.97168,402.02637,356.97168,220.66553,501.90137,175.76416,701.583Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 899.63335,
    cy: 219.90276,
    r: 54.31516,
    fill: "#ff6584"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 877,
    y: 437.05664,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M928.95773,638.096c.12732,27.62433-19.30786,50.10833-19.30786,50.10833s-19.6416-22.3039-19.76892-49.92823,19.30786-50.10833,19.30786-50.10833S928.83041,610.47163,928.95773,638.096Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M928.95773,638.096c.12732,27.62433-19.30786,50.10833-19.30786,50.10833s-19.6416-22.3039-19.76892-49.92823,19.30786-50.10833,19.30786-50.10833S928.83041,610.47163,928.95773,638.096Z",
    transform: "translate(-31.5 -190.97168)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.02166,
    cy: 248.742,
    r: 31.2479,
    fill: "#ff8ba2",
    opacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.18972,
    cy: 263.66637,
    r: 21.92017,
    fill: "#ff8ba2",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.18972,
    cy: 326.66637,
    r: 21.92017,
    fill: "#ff8ba2",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 856.31222,
    cy: 246.17134,
    r: 31.2479,
    fill: "#ff8ba2",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.13058,698.24412c1.694,6.26184,7.4961,10.14,7.4961,10.14s3.05572-6.27434,1.36177-12.53618-7.49609-10.14-7.49609-10.14S86.43664,691.98227,88.13058,698.24412Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.61972,696.89838c4.64821,4.52485,5.216,11.4806,5.216,11.4806s-6.9685-.38049-11.61672-4.90534-5.216-11.48059-5.216-11.48059S85.9715,692.37353,90.61972,696.89838Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M700.13058,698.24412c1.69395,6.26184,7.4961,10.14,7.4961,10.14s3.05572-6.27434,1.36177-12.53618-7.49609-10.14-7.49609-10.14S698.43664,691.98227,700.13058,698.24412Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M702.61972,696.89838c4.64821,4.52485,5.216,11.4806,5.216,11.4806s-6.9685-.38049-11.61672-4.90534-5.216-11.48059-5.216-11.48059S697.9715,692.37353,702.61972,696.89838Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "68.137 460.203 64 453.308 102.614 420.21 201.908 420.21 201.908 429.863 166.052 468.478 124.679 476.752 68.137 460.203",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "219 439.633 219 418.056 206 418.056 206 424.86 201.908 420.21 168.81 453.308 163.293 458.824 156.398 486.406 168.81 516.745 232.247 516.745 232.247 454.687 219 439.633",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 453.30771,
    width: 104.80978,
    height: 63.4375,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132.26427,
    y: 473.30431,
    width: 22.06522,
    height: 19.30707,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.99321,
    y: 472.61477,
    width: 19.30707,
    height: 44.13043,
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "81.928 479.51 81.928 472.615 73.654 472.615 73.654 479.51 81.238 479.51 81.928 479.51",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "81.238 485.026 73.654 485.026 73.654 491.922 81.928 491.922 81.928 485.026 81.238 485.026",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.44429,
    y: 472.61477,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 87.44429,
    y: 485.02646,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.46 480.2 198.46 473.304 190.185 473.304 190.185 480.2 197.77 480.2 198.46 480.2",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.77 485.716 190.185 485.716 190.185 492.611 198.46 492.611 198.46 485.716 197.77 485.716",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 203.97622,
    y: 473.30431,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 203.97622,
    y: 485.716,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.137 460.203 463 453.308 501.614 420.21 600.908 420.21 600.908 429.863 565.052 468.478 523.679 476.752 467.137 460.203",
    fill: "#3f3d56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "618 439.633 618 418.056 605 418.056 605 424.86 600.908 420.21 567.81 453.308 562.293 458.824 555.398 486.406 567.81 516.745 631.247 516.745 631.247 454.687 618 439.633",
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 453.30771,
    width: 104.80978,
    height: 63.4375,
    fill: "#f2f2f2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 531.26427,
    y: 473.30431,
    width: 22.06522,
    height: 19.30707,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 502.99321,
    y: 472.61477,
    width: 19.30707,
    height: 44.13043,
    fill: "#ccc"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "480.928 479.51 480.928 472.615 472.654 472.615 472.654 479.51 480.238 479.51 480.928 479.51",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "480.238 485.026 472.654 485.026 472.654 491.922 480.928 491.922 480.928 485.026 480.238 485.026",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 486.44429,
    y: 472.61477,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 486.44429,
    y: 485.02646,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "597.46 480.2 597.46 473.304 589.185 473.304 589.185 480.2 596.77 480.2 597.46 480.2",
    fill: "#3f3d56"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "596.77 485.716 589.185 485.716 589.185 492.611 597.46 492.611 597.46 485.716 596.77 485.716",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 602.97622,
    y: 473.30431,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 602.97622,
    y: 485.716,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.515 344.361 273.62 338.844 312.234 304.367 410.148 304.367 410.148 334.707 346.711 377.459 280.515 344.361",
    fill: "#3f3d56"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "428 323.707 428 305.056 415 305.056 415 309.624 410.148 304.367 378.429 338.844 366.018 347.119 346.773 487.722 375.796 516.745 443.246 516.745 443.246 340.223 428 323.707",
    fill: "#ccc"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 273.61957,
    y: 338.84439,
    width: 104.80978,
    height: 177.90082,
    fill: "#f2f2f2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 314.30231,
    y: 473.30431,
    width: 19.30707,
    height: 43.4409,
    fill: "#ccc"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.616 485.716 293.616 478.821 285.342 478.821 285.342 485.716 292.927 485.716 293.616 485.716",
    fill: "#3f3d56"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.927 491.232 285.342 491.232 285.342 498.128 293.616 498.128 293.616 491.232 292.927 491.232",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 299.13247,
    y: 478.82062,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 299.13247,
    y: 491.2323,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "350.158 485.716 350.158 478.821 341.884 478.821 341.884 485.716 349.469 485.716 350.158 485.716",
    fill: "#3f3d56"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "349.469 491.232 341.884 491.232 341.884 498.128 350.158 498.128 350.158 491.232 349.469 491.232",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 355.67459,
    y: 478.82062,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 355.67459,
    y: 491.2323,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.079 347.808 408.079 340.913 399.805 340.913 399.805 347.808 407.39 347.808 408.079 347.808",
    fill: "#3f3d56"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 353.325 399.805 353.325 399.805 360.22 408.079 360.22 408.079 353.325 407.39 353.325",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 340.91301,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 353.32469,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.079 386.423 408.079 379.527 399.805 379.527 399.805 386.423 407.39 386.423 408.079 386.423",
    fill: "#3f3d56"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 391.939 399.805 391.939 399.805 398.834 408.079 398.834 408.079 391.939 407.39 391.939",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 379.52714,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 391.93882,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.079 425.037 408.079 418.141 399.805 418.141 399.805 425.037 407.39 425.037 408.079 425.037",
    fill: "#3f3d56"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 430.553 399.805 430.553 399.805 437.448 408.079 437.448 408.079 430.553 407.39 430.553",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 418.14127,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 430.55295,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.079 463.651 408.079 456.755 399.805 456.755 399.805 463.651 407.39 463.651 408.079 463.651",
    fill: "#3f3d56"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 469.167 399.805 469.167 399.805 476.062 408.079 476.062 408.079 469.167 407.39 469.167",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 456.7554,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 413.59579,
    y: 469.16708,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 285.34171,
    y: 347.80839,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 285.34171,
    y: 380.90621,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 285.34171,
    y: 414.00404,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 285.34171,
    y: 447.10187,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.515 344.361 676.62 338.844 715.234 304.367 813.148 304.367 813.148 334.707 749.711 377.459 683.515 344.361",
    fill: "#3f3d56"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "831 323.707 831 305.056 818 305.056 818 309.624 813.148 304.367 781.429 338.844 769.018 347.119 749.773 487.722 778.796 516.745 846.246 516.745 846.246 340.223 831 323.707",
    fill: "#ccc"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 676.61957,
    y: 338.84439,
    width: 104.80978,
    height: 177.90082,
    fill: "#f2f2f2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 717.30231,
    y: 473.30431,
    width: 19.30707,
    height: 43.4409,
    fill: "#ccc"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "696.616 485.716 696.616 478.821 688.342 478.821 688.342 485.716 695.927 485.716 696.616 485.716",
    fill: "#3f3d56"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "695.927 491.232 688.342 491.232 688.342 498.128 696.616 498.128 696.616 491.232 695.927 491.232",
    fill: "#3f3d56"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 702.13247,
    y: 478.82062,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 702.13247,
    y: 491.2323,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "753.158 485.716 753.158 478.821 744.884 478.821 744.884 485.716 752.469 485.716 753.158 485.716",
    fill: "#3f3d56"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "752.469 491.232 744.884 491.232 744.884 498.128 753.158 498.128 753.158 491.232 752.469 491.232",
    fill: "#3f3d56"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 758.67459,
    y: 478.82062,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 758.67459,
    y: 491.2323,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "811.079 347.808 811.079 340.913 802.805 340.913 802.805 347.808 810.39 347.808 811.079 347.808",
    fill: "#3f3d56"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "810.39 353.325 802.805 353.325 802.805 360.22 811.079 360.22 811.079 353.325 810.39 353.325",
    fill: "#3f3d56"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 340.91301,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 353.32469,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "811.079 386.423 811.079 379.527 802.805 379.527 802.805 386.423 810.39 386.423 811.079 386.423",
    fill: "#3f3d56"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "810.39 391.939 802.805 391.939 802.805 398.834 811.079 398.834 811.079 391.939 810.39 391.939",
    fill: "#3f3d56"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 379.52714,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 391.93882,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "811.079 425.037 811.079 418.141 802.805 418.141 802.805 425.037 810.39 425.037 811.079 425.037",
    fill: "#3f3d56"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "810.39 430.553 802.805 430.553 802.805 437.448 811.079 437.448 811.079 430.553 810.39 430.553",
    fill: "#3f3d56"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 418.14127,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 430.55295,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "811.079 463.651 811.079 456.755 802.805 456.755 802.805 463.651 810.39 463.651 811.079 463.651",
    fill: "#3f3d56"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "810.39 469.167 802.805 469.167 802.805 476.062 811.079 476.062 811.079 469.167 810.39 469.167",
    fill: "#3f3d56"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 456.7554,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 816.59579,
    y: 469.16708,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 688.34171,
    y: 347.80839,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 688.34171,
    y: 380.90621,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 688.34171,
    y: 414.00404,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 688.34171,
    y: 447.10187,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "904.515 344.361 897.62 338.844 936.234 304.367 1034.148 304.367 1034.148 334.707 970.711 377.459 904.515 344.361",
    fill: "#3f3d56"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "1052 323.707 1052 305.056 1039 305.056 1039 309.624 1034.148 304.367 1002.429 338.844 990.018 347.119 970.773 487.722 999.796 516.745 1067.246 516.745 1067.246 340.223 1052 323.707",
    fill: "#ccc"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 897.61957,
    y: 338.84439,
    width: 104.80978,
    height: 177.90082,
    fill: "#f2f2f2"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 938.30231,
    y: 473.30431,
    width: 19.30707,
    height: 43.4409,
    fill: "#ccc"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "917.616 485.716 917.616 478.821 909.342 478.821 909.342 485.716 916.927 485.716 917.616 485.716",
    fill: "#3f3d56"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "916.927 491.232 909.342 491.232 909.342 498.128 917.616 498.128 917.616 491.232 916.927 491.232",
    fill: "#3f3d56"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 923.13247,
    y: 478.82062,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 923.13247,
    y: 491.2323,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "974.158 485.716 974.158 478.821 965.884 478.821 965.884 485.716 973.469 485.716 974.158 485.716",
    fill: "#3f3d56"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "973.469 491.232 965.884 491.232 965.884 498.128 974.158 498.128 974.158 491.232 973.469 491.232",
    fill: "#3f3d56"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 979.67459,
    y: 478.82062,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 979.67459,
    y: 491.2323,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "1032.079 347.808 1032.079 340.913 1023.805 340.913 1023.805 347.808 1031.39 347.808 1032.079 347.808",
    fill: "#3f3d56"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "1031.39 353.325 1023.805 353.325 1023.805 360.22 1032.079 360.22 1032.079 353.325 1031.39 353.325",
    fill: "#3f3d56"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 340.91301,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 353.32469,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "1032.079 386.423 1032.079 379.527 1023.805 379.527 1023.805 386.423 1031.39 386.423 1032.079 386.423",
    fill: "#3f3d56"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "1031.39 391.939 1023.805 391.939 1023.805 398.834 1032.079 398.834 1032.079 391.939 1031.39 391.939",
    fill: "#3f3d56"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 379.52714,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 391.93882,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "1032.079 425.037 1032.079 418.141 1023.805 418.141 1023.805 425.037 1031.39 425.037 1032.079 425.037",
    fill: "#3f3d56"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "1031.39 430.553 1023.805 430.553 1023.805 437.448 1032.079 437.448 1032.079 430.553 1031.39 430.553",
    fill: "#3f3d56"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 418.14127,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 430.55295,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "1032.079 463.651 1032.079 456.755 1023.805 456.755 1023.805 463.651 1031.39 463.651 1032.079 463.651",
    fill: "#3f3d56"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "1031.39 469.167 1023.805 469.167 1023.805 476.062 1032.079 476.062 1032.079 469.167 1031.39 469.167",
    fill: "#3f3d56"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 456.7554,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.59579,
    y: 469.16708,
    width: 8.27446,
    height: 6.89538,
    fill: "#3f3d56"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 909.34171,
    y: 347.80839,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 909.34171,
    y: 380.90621,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 909.34171,
    y: 414.00404,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 909.34171,
    y: 447.10187,
    width: 79.98641,
    height: 16.54891,
    fill: "#3f3d56"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    y: 516.05664,
    width: 1137,
    height: 2,
    fill: "#3f3d56"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 437.05664,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.95773,638.096c.12732,27.62433-19.30786,50.10833-19.30786,50.10833s-19.6416-22.3039-19.76892-49.92823,19.30786-50.10833,19.30786-50.10833S303.83041,610.47163,303.95773,638.096Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 437.05664,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M503.95773,638.096c.12732,27.62433-19.30786,50.10833-19.30786,50.10833s-19.6416-22.3039-19.76892-49.92823,19.30786-50.10833,19.30786-50.10833S503.83041,610.47163,503.95773,638.096Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 851,
    y: 437.05664,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M902.95773,638.096c.12732,27.62433-19.30786,50.10833-19.30786,50.10833s-19.6416-22.3039-19.76892-49.92823,19.30786-50.10833,19.30786-50.10833S902.83041,610.47163,902.95773,638.096Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 587.5,
    cy: 163.5,
    rx: 38,
    ry: 8.55,
    fill: "#ff8ba2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M662,234.97168c0,24.30053-44,93-44,93s-44-68.69947-44-93a44,44,0,0,1,88,0Z",
    transform: "translate(-31.5 -190.97168)",
    fill: "#ff8ba2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.5,
    cy: 44,
    r: 25,
    fill: "#f2f2f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityLocationsRed);
export default __webpack_public_path__ + "static/media/CityLocationsRED.0bb181ad.svg";
export { ForwardRef as ReactComponent };